module.exports = __webpack_public_path__ + "static/media/coding-blocks_logo.63747fac.png";